import { all, put, takeEvery, call } from "redux-saga/effects";
import { GET_CURRENT_CYCLE_DETAILS } from "../../actions/GetCurrentCycleDetails/GetCurrentCycleDetailsType";
import { apiPython as api } from "../../../service/api";
import URLs from "../../../constants/urls";
import { getCurrentCycleDetails, setCurrentCycleFailureAction } from "../../features/GetCycleCurrentDetails/GetCycleCurrentDetailsSlice";

export function* getCurrentCycle({ payload }) {
    try {
        const { employeeId, cycleId } = payload;
        const response = yield api.get(`${URLs.GET_CURRENT_CYCLE_DETAILS}?employeeId=${employeeId}&cycleId=${cycleId}`);
        console.log('Response - Current Cycle:', response);
        yield put(getCurrentCycleDetails(response.data));
    } catch (error) {
        console.log('Error - Current Cycle:', error);
        const errorMessage = error?.response?.data?.message || 'Could not fetch current cycle details';
        yield put(setCurrentCycleFailureAction(errorMessage));
    }
}

export function* watchCurrentCycle() {
    yield takeEvery(GET_CURRENT_CYCLE_DETAILS, getCurrentCycle);
}

export default function* manageCurrentCycleSaga() {
    yield all([watchCurrentCycle()]);
}
